import { useContext } from 'react';

import { PaymentContext } from 'src/components/common/PaymentProvider';

export default (method) => {
  const paymentModules = useContext(PaymentContext);

  return paymentModules?.[method];
};
